import script from "./BssMapDestinationInfobox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BssMapDestinationInfobox.vue?vue&type=script&lang=ts&setup=true"

import "./BssMapDestinationInfobox.vue?vue&type=style&index=0&id=5b6644d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b6644d3"]])

export default __exports__